// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export function getObjectKeys<T extends {}>(object: T) {
    const keys = Object.keys(object) as (keyof T)[];

    return keys;
}
